import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ThemeProvider } from '@material-ui/core/styles';

import theme from 'theme';
import { store } from 'store';
import Routes from 'core/routes';
import services from 'core/services';
import { fetchApi } from 'core/services/fetchApi';
import { logout } from 'utils/logout';
import Hubspot from 'views/Hubspot';
import SnackbarProvider from 'components/SnackbarProvider';
import DevTools from 'dev';

import './global.scss';

const { REACT_APP_RECAPTCHA_SITE_KEY: recaptchaKey } = process.env;
const { isSnackbar } = services;

fetchApi.isSnackbar = isSnackbar;
fetchApi.logout = logout;

ReactDOM.render(
  <Hubspot>
    <Provider store={store}>
      <GoogleReCaptchaProvider
        language="en"
        reCaptchaKey={recaptchaKey}
        container={{
          parameters: {
            badge: 'bottomleft',
          },
        }}
      >
        <ThemeProvider theme={theme}>
          <EmotionThemeProvider theme={theme}>
            <SnackbarProvider>
              <Router basename="/">
                <DevTools />
                <Routes />
              </Router>
            </SnackbarProvider>
          </EmotionThemeProvider>
        </ThemeProvider>
      </GoogleReCaptchaProvider>
    </Provider>
  </Hubspot>,
  document.getElementById('root'),
);
